import { Text } from "@components";
import { useTranslation } from "react-i18next";
import theme from "../../theme";
import EventNoteIcon from "@mui/icons-material/EventNote";
import InputIcon from "@mui/icons-material/Input";
import GradingIcon from "@mui/icons-material/Grading";

const InfoProgressBar = ({ currentIndex = 0 }) => {
  const { t } = useTranslation("common");
  const boxData = [
    {
      id: 1,
      icon: null,
      title: t("book.reservation"),
      iconActive: <EventNoteIcon sx={{ color: theme.colors.white }} />,
      iconInactive: <EventNoteIcon sx={{ color: theme.colors.buttonColor }} />,
    },
    {
      id: 2,
      icon: null,
      title: t("book.checkout"),
      iconActive: <InputIcon sx={{ color: theme.colors.white }} />,
      iconInactive: <InputIcon sx={{ color: theme.colors.buttonColor }} />,
    },
    {
      id: 3,
      icon: null,
      title: t("book.complete"),
      iconActive: <GradingIcon sx={{ color: theme.colors.white }} />,
      iconInactive: <GradingIcon sx={{ color: theme.colors.buttonColor }} />,
    },
  ];

  return (
    <div
      className={`flex flex-col lg:flex-row lg:justify-between w-full lg:h-[54px] bg-white ${
        currentIndex == 0 ? "rounded-t-lg" : "rounded-lg"
      } gap-2 lg:gap-0 shadow-[0_0px_15px_0px_#cdcaec]`}
    >
      {boxData.map((data, index) => {
        return (
          <div
            key={index}
            className={`flex w-full justify-center items-center  gap-2 lg:gap-4 p-2 lg:p-0 ${
              currentIndex == index
                ? `bg-buttonColor ${
                    currentIndex == 0
                      ? "rounded-t-lg rounded-br-lg"
                      : "rounded-lg"
                  }`
                : ` bg-white ${
                    currentIndex == 0 ? "rounded-t-lg" : "rounded-lg"
                  }`
            }`}
          >
            {currentIndex == index ? data.iconActive : data.iconInactive}
            <Text
              className={`font-sans text-[18px] font-normal ${
                currentIndex == index ? "text-buttonTextColor" : "text-blackText"
              }`}
            >
              {data.title}
            </Text>
          </div>
        );
      })}
    </div>
  );
};

export default InfoProgressBar;
